import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=2ccae3f3&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=ts&"
export * from "./Player.vue?vue&type=script&lang=ts&"
import style0 from "./Player.vue?vue&type=style&index=0&id=2ccae3f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccae3f3",
  null
  
)

export default component.exports